const normalizeLabel = (value = '') =>
  value
    .normalize('NFD')
    .replaceAll(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()

const getSelectedIndex = (data) => data.findIndex((item) => item.value > 0)

export const createEmptyDonutChartResponse = () => ({
  total: 0,
  data: [],
})

export const mapDonutChartResponse = (response, config) => {
  const apiData = Array.isArray(response?.data) ? response.data : []
  const valueByName = new Map(apiData.map((item) => [normalizeLabel(item.name), Number(item.value) || 0]))

  const selectedIndex = getSelectedIndex(
    config.segments.map((segment) => ({
      value: valueByName.get(normalizeLabel(segment.name)) ?? 0,
    }))
  )

  const data = config.segments.map((segment, index) => ({
    name: segment.name,
    value: valueByName.get(normalizeLabel(segment.name)) ?? 0,
    color: segment.color,
    selected: index === selectedIndex,
  }))

  const total =
    typeof response?.total === 'number'
      ? response.total
      : data.reduce((accumulator, item) => accumulator + item.value, 0)

  return { total, data }
}
